module.exports = __webpack_public_path__ + "static/eatseverything_1-1c817f9873a9cae4c95794dd9dddca05.jpg";